import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthsListRowFn = /* @__PURE__ */ createRecipe('calendar-months-list-row', {}, [])

const calendarMonthsListRowVariantMap = {}

const calendarMonthsListRowVariantKeys = Object.keys(calendarMonthsListRowVariantMap)

export const calendarMonthsListRow = /* @__PURE__ */ Object.assign(memo(calendarMonthsListRowFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthsListRow',
  __getCompoundVariantCss__: calendarMonthsListRowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthsListRowVariantKeys,
  variantMap: calendarMonthsListRowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthsListRowVariantKeys)
  },
  getVariantProps: calendarMonthsListRowFn.getVariantProps,
})